import Vue from 'vue'

import 'normalize.css/normalize.css'// A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import '@/styles/index.scss' // global css

import App from './App'
import router from './router'
import store from './store'

import i18n from './locale'
import '@/icons'
import '@/permission'

import 'vue2vis/dist/vue2vis.css'

import VueMoment from 'vue-moment'
import 'moment/locale/zh-tw'
import moment from 'moment-timezone'

import * as VueGoogleMaps from 'vue2-google-maps'

import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'

import 'flag-icons/css/flag-icons.min.css'

import VueClipboard from 'vue-clipboard2'
import tinymce from 'vue-tinymce-editor'

import Base from '@/components/base'

import { VueReCaptcha } from 'vue-recaptcha-v3'

import JsonEditor from 'vue-json-edit'

Vue.use(JsonEditor)

Vue.use(VueReCaptcha, {
  siteKey: '6LdF7ssZAAAAAHSmZuxqmGrdYWK_JSh_JiCI1CyA'
})

Vue.use(Viewer, {
  // debug: true,
  defaultOptions: {
    zIndex: 9999
  }
})
Vue.use(ElementUI, {
  size: 'medium', // set element-ui default size
  i18n: (key, value) => i18n.t(key, value)
})
Vue.use(VueMoment, {
  moment
})
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyD93ZqApPXOB7VNUKQty4J7_JIMugl0tnA',
    libraries: 'geometry,places,visualization'

    // - If you want to set the version, you can do so:
    // v: '3.26',
  }

  // - If you intend to programmatically custom event listener code
  // - (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  // - instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  // - you might need to turn this on.
  // autobindAllEvents: false,

  // - If you want to manually install components, e.g.
  // - import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  // - Vue.component('GmapMarker', GmapMarker)
  // - then disable the following:
  // installComponents: true,
})
Vue.use(VueClipboard)
Vue.use(Base)
Vue.component('tinymce', tinymce)

Vue.config.productionTip = false

var ebus = new Vue({})

Object.defineProperty(Vue.prototype, '$ebus', {
  get () {
    return this.$root.ebus
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  data () {
    return {
      ebus: ebus
    }
  },
  router,
  store,
  i18n,
  render: h => h(App)
})
